var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import React, { Component } from 'react';
import { FieldType } from '../../../elements';
import { rules } from '../../../helpers/Validation';
import { Form } from '../../../components';
var SchedulesForm = /** @class */ (function (_super) {
    __extends(SchedulesForm, _super);
    function SchedulesForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fields = [
            {
                name: 'hours',
                type: FieldType.Text,
                rules: rules()
                    .number()
                    .between(0, 23)
                    .required(),
                size: 4
            },
            {
                name: 'minutes',
                type: FieldType.Text,
                rules: rules()
                    .number()
                    .between(0, 59)
                    .required(),
                size: 4
            },
        ];
        return _this;
    }
    SchedulesForm.prototype.render = function () {
        var schedule = this.props.schedule;
        var scheduleStore = this.props.store.scheduleStore;
        console.log('schedule', schedule);
        return (React.createElement("div", null,
            React.createElement(Form, { loading: ['post@operationlines/', 'put@operationlines/'], fields: this.fields, values: schedule, store: scheduleStore })));
    };
    SchedulesForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id
                ? props.store.scheduleStore.read(props.match.params.id).then(function (schedule) { return ({ schedule: schedule }); })
                : undefined,
        ]; }),
        observer
    ], SchedulesForm);
    return SchedulesForm;
}(Component));
export default SchedulesForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Schedules/containers/SchedulesForm.tsx
// module id = 1559
// module chunks = 0